import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { ROUTES } from '../../utils/AppConstants'
import { isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee } from '../../utils/Utils'

const RouteGuard = ({ children }) => {
    const location = useLocation();
    const { isLogin, user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const currentPath = location.pathname;
    const isBusinessUser = isLoggedInUserBusiness(user);
    const isEmployeeUser = isLoggedInUserEmployee(user);
    const subscriptionEnded = user?.data?.userDetails?.subscriptionEnded === true;

    // Not logged in → redirect to home
    if (!isLogin) {
        return <Navigate to={ROUTES.home} replace />;
    }

    // Business user with expired subscription → force to subscriptionRenew
    if (isBusinessUser && subscriptionEnded && currentPath !== ROUTES.subscriptionRenew) {
        return <Navigate to={ROUTES.subscriptionRenew} replace />;
    }

    // Allow access to /subscriptionRenew for business user with expired subscription
    // if (currentPath === ROUTES.subscriptionRenew) {
    //     return children;
    // }

    // Employee: force location selection if not selected
    if (
        isEmployeeUser &&
        isEmpty(employeeSelectedBusiness) &&
        isEmpty(employeeSelectedLocation) &&
        currentPath !== ROUTES.employee.selectLocation
    ) {
        return <Navigate to={ROUTES.employee.selectLocation} replace />;
    }

    // All checks passed → allow access
    return children;
}

export default RouteGuard
// const RouteGuard = ({ children }) => {
//     const { isLogin, user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
//     if (!isLogin) {
//         return <Navigate to={ROUTES.home} />;
//     }
//     if (isLoggedInUserEmployee(user) && children?.type?.name === 'EmployeeChangePassword') {
//         return children
//     }

//     if (isLoggedInUserEmployee(user) && children?.type?.name === 'EmployeeSelectLocation') {
//         return children
//     }

//     if (isLoggedInUserBusiness(user) && children?.type?.name === 'SubscriptionRenewScreen') {
//         return children
//     }

//     if (isLoggedInUserEmployee(user) && isEmpty(employeeSelectedBusiness) && isEmpty(employeeSelectedLocation)) {
//         return <Navigate to={ROUTES.employee.selectLocation} />
//     }
//     if (isLoggedInUserBusiness(user) && user.data.userDetails.subscriptionEnded === true) {
//         return <Navigate to={ROUTES.subscriptionRenew} />
//     }
//     return children;
// }

// export default RouteGuard